// extracted by mini-css-extract-plugin
export var checked = "ConfirmCheckbox-module--checked--SpuQh";
export var confirmButtonHover = "ConfirmCheckbox-module--confirmButtonHover--UsUs2";
export var itemConfirm = "ConfirmCheckbox-module--itemConfirm--5iRfR";